import React, { useState, useEffect } from "react";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import "../dashboard/dashboard.css";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx-js-style";

const UnitAnalysisStatus = () => {
    const apiService = new LeaseApiService();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);

    const [formData, setFormData] = useState({
        property: "",
    })

    const toPercent = (value) => Number(value || 0).toFixed(2);

    useEffect(() => {
        fetchDropdownData()
        getItems(1)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }

    const getItems = async (newPageNo = pagination?.currentPage, filters = formData) => {
        try {
            setExportData(null)
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("PropertyName", filters?.property?.label || "All");

            const res = await apiService.getApiParamater("REPORT_UNIT_ANALYSIS_STATUS", `?${params.toString()}`);

            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData, filters)
                setLoading(false);
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching items:", error);
            setLoading(false);
        }
    }

    const getAllItems = async (total, filters = formData) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords || 0);
            params.append("PropertyName", filters?.property?.label || "All");

            const res = await apiService.getApiParamater("REPORT_UNIT_ANALYSIS_STATUS", `?${params.toString()}`);

            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
                setLoader(false)
            } else {
                setLoader(false)
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
        }
    }

    const handleClearFilters = () => {
        setRowData([])
        setExportData([])
        setPagination()
        setFormData({
            property: "",
        });
        getItems(1, { property: "" });
    }

    const handleDropDownChange = ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }

    // Data columns, grouped exactly like the on-screen grid (Property Name is 3 merged columns, then 3 groups x 6 columns)
    const dataColumns = [
        { group: "developer", header: "Total", field: "total" },
        { group: "developer", header: "Occupied", field: "occupied" },
        { group: "developer", header: "Occupied %", field: "occu_Per", isPercent: true },
        { group: "developer", header: "Vacant", field: "vacant" },
        { group: "developer", header: "On Notice", field: "onNotice" },
        { group: "developer", header: "Expected Arrival", field: "expectedArrival" },
        { group: "pm", header: "Total", field: "pM_Total" },
        { group: "pm", header: "Occupied", field: "pM_Occupied" },
        { group: "pm", header: "Occupied %", field: "pM_Occu_Per", isPercent: true },
        { group: "pm", header: "Vacant", field: "pM_Vacant" },
        { group: "pm", header: "On Notice", field: "pM_OnNotice" },
        { group: "pm", header: "Expected Arrival", field: "pM_ExpectedArrival" },
        { group: "overall", header: "Total", field: "property_Total" },
        { group: "overall", header: "Occupied", field: "property_Occupied" },
        { group: "overall", header: "Occupied %", field: "occupied_Per", isPercent: true },
        { group: "overall", header: "Vacant", field: "property_Vacant" },
        { group: "overall", header: "Notice", field: "property_Notice" },
        { group: "overall", header: "Expected Arrival", field: "property_ExpectedArrival" },
    ];
    const PROPERTY_COLS = 3; // matches colSpan="3" used for Property Name in the grid
    const TOTAL_COLS = PROPERTY_COLS + dataColumns.length;

    // Same colours as the grid headers (dashboard.css: .developer-header/.pm-header/.overall-header and their subheaders)
    const groupColors = {
        developer: { header: "FF4EE6F0", sub: "FFADF3F8", subText: "FF4D3970" },
        pm: { header: "FFD0CECE", sub: "FFD0CECE", subText: "FF315D7E" },
        overall: { header: "FFA7F7CE", sub: "FFC8F6DE", subText: "FF28634F" },
    };

    const exportExcel = () => {
        if (!exportData?.length) {
            toast.warning("No data to export");
            return;
        }

        const groupHeaderRow = new Array(TOTAL_COLS).fill("");
        groupHeaderRow[0] = "Property Name";
        groupHeaderRow[PROPERTY_COLS] = "Developer";
        groupHeaderRow[PROPERTY_COLS + 6] = "PM";
        groupHeaderRow[PROPERTY_COLS + 12] = "Overall";

        const subHeaderRow = new Array(TOTAL_COLS).fill("");
        dataColumns.forEach((col, i) => {
            subHeaderRow[PROPERTY_COLS + i] = col.header;
        });

        const dataRows = exportData.map((item) => {
            const row = new Array(TOTAL_COLS).fill("");
            row[0] = item.propertyName || "-";
            dataColumns.forEach((col, i) => {
                row[PROPERTY_COLS + i] = col.isPercent
                    ? Number(toPercent(item[col.field]))
                    : Number(item[col.field]) || 0;
            });
            return row;
        });

        const totalsRow = new Array(TOTAL_COLS).fill("");
        totalsRow[0] = "Total:";
        dataColumns.forEach((col, i) => {
            if (col.isPercent) {
                const occField = col.field === "occu_Per" ? "occupied" : col.field === "pM_Occu_Per" ? "pM_Occupied" : "property_Occupied";
                const totField = col.field === "occu_Per" ? "total" : col.field === "pM_Occu_Per" ? "pM_Total" : "property_Total";
                const occSum = exportData.reduce((sum, item) => sum + (Number(item[occField]) || 0), 0);
                const totSum = exportData.reduce((sum, item) => sum + (Number(item[totField]) || 0), 0);
                totalsRow[PROPERTY_COLS + i] = Number((((occSum / totSum) * 100) || 0).toFixed(2));
            } else {
                totalsRow[PROPERTY_COLS + i] = exportData.reduce((sum, item) => sum + (Number(item[col.field]) || 0), 0);
            }
        });

        const titleRow = new Array(TOTAL_COLS).fill("");
        titleRow[0] = "UNIT ANALYSIS STATUS REPORT";

        const worksheet = XLSX.utils.aoa_to_sheet([
            titleRow,
            groupHeaderRow,
            subHeaderRow,
            ...dataRows,
            totalsRow,
        ]);

        const dataStartRow = 3;
        const totalsRowIndex = dataStartRow + dataRows.length;

        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: TOTAL_COLS - 1 } }, // title
            { s: { r: 1, c: 0 }, e: { r: 2, c: PROPERTY_COLS - 1 } }, // Property Name (rowspan 2, colspan 3)
            { s: { r: 1, c: PROPERTY_COLS }, e: { r: 1, c: PROPERTY_COLS + 5 } }, // Developer
            { s: { r: 1, c: PROPERTY_COLS + 6 }, e: { r: 1, c: PROPERTY_COLS + 11 } }, // PM
            { s: { r: 1, c: PROPERTY_COLS + 12 }, e: { r: 1, c: PROPERTY_COLS + 17 } }, // Overall
            ...dataRows.map((_, i) => ({ s: { r: dataStartRow + i, c: 0 }, e: { r: dataStartRow + i, c: PROPERTY_COLS - 1 } })),
            { s: { r: totalsRowIndex, c: 0 }, e: { r: totalsRowIndex, c: PROPERTY_COLS - 1 } },
        ];

        worksheet["!cols"] = new Array(TOTAL_COLS).fill(null).map((_, i) => {
            if (i < PROPERTY_COLS) return { wch: 12 };
            const col = dataColumns[i - PROPERTY_COLS];
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map((r) => String(r[i] ?? "").length),
                String(totalsRow[i] ?? "").length
            );
            return { wch: Math.min(Math.max(maxLength + 3, 10), 22) };
        });

        worksheet["!rows"] = [{ hpt: 28 }, { hpt: 26 }, { hpt: 26 }];
        worksheet["!freeze"] = { xSplit: PROPERTY_COLS, ySplit: dataStartRow };

        const borderStyle = {
            top: { style: "thin", color: { rgb: "FFBFBFBF" } },
            bottom: { style: "thin", color: { rgb: "FFBFBFBF" } },
            left: { style: "thin", color: { rgb: "FFBFBFBF" } },
            right: { style: "thin", color: { rgb: "FFBFBFBF" } },
        };

        const setCell = (r, c, style, opts = {}) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r, c })];
            if (!cell) return;
            cell.s = style;
            if (opts.numFmt) {
                cell.t = "n";
                cell.z = opts.numFmt;
            }
        };

        // Title row
        setCell(0, 0, {
            font: { bold: true, sz: 16, color: { rgb: "FFFFFFFF" } },
            fill: { fgColor: { rgb: "FF6E5199" } },
            alignment: { horizontal: "left", vertical: "center" },
            border: borderStyle,
        });

        // Group header row (Property Name + Developer/PM/Overall)
        setCell(1, 0, {
            font: { bold: true, sz: 11, color: { rgb: "FF000000" } },
            fill: { fgColor: { rgb: "FFFFFFFF" } },
            alignment: { horizontal: "center", vertical: "center" },
            border: borderStyle,
        });
        for (let c = PROPERTY_COLS; c < TOTAL_COLS; c++) {
            const group = dataColumns[c - PROPERTY_COLS].group;
            setCell(1, c, {
                font: { bold: true, sz: 11, color: { rgb: "FF000000" } },
                fill: { fgColor: { rgb: groupColors[group].header } },
                alignment: { horizontal: "center", vertical: "center" },
                border: borderStyle,
            });
        }

        // Sub header row
        setCell(2, 0, {
            font: { bold: true, sz: 10, color: { rgb: "FF000000" } },
            fill: { fgColor: { rgb: "FFFFFFFF" } },
            border: borderStyle,
        });
        dataColumns.forEach((col, i) => {
            const c = PROPERTY_COLS + i;
            setCell(2, c, {
                font: { bold: true, sz: 10, color: { rgb: groupColors[col.group].subText } },
                fill: { fgColor: { rgb: groupColors[col.group].sub } },
                alignment: { horizontal: "center", vertical: "center", wrapText: true },
                border: borderStyle,
            });
        });

        // Data rows
        dataRows.forEach((row, r) => {
            const rowIndex = dataStartRow + r;
            const rowFill = r % 2 === 1 ? "FFFAFAFA" : "FFFFFFFF";

            setCell(rowIndex, 0, {
                font: { bold: true, sz: 10, color: { rgb: "FF000000" } },
                fill: { fgColor: { rgb: rowFill } },
                alignment: { horizontal: "left", vertical: "center" },
                border: borderStyle,
            });

            dataColumns.forEach((col, i) => {
                const c = PROPERTY_COLS + i;
                setCell(rowIndex, c, {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    fill: { fgColor: { rgb: rowFill } },
                    alignment: { horizontal: "center", vertical: "center" },
                    border: borderStyle,
                }, { numFmt: col.isPercent ? '0.00"%"' : "#,##0" });
            });
        });

        // Totals row
        setCell(totalsRowIndex, 0, {
            font: { bold: true, sz: 10, color: { rgb: "FF000000" } },
            fill: { fgColor: { rgb: "FFF1F1F1" } },
            alignment: { horizontal: "left", vertical: "center" },
            border: borderStyle,
        });
        dataColumns.forEach((col, i) => {
            const c = PROPERTY_COLS + i;
            setCell(totalsRowIndex, c, {
                font: { bold: true, sz: 10, color: { rgb: "FF000000" } },
                fill: { fgColor: { rgb: "FFF1F1F1" } },
                alignment: { horizontal: "center", vertical: "center" },
                border: borderStyle,
            }, { numFmt: col.isPercent ? '0.00"%"' : "#,##0" });
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Unit Analysis Status");
        XLSX.writeFile(workbook, "Unit_Analysis_Status_Report.xlsx");
    };

    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex gap-1 ms-auto">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => getItems(1)} className="mainbtnGry flex-end gap-2 w-50">
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Unit Analysis Status Report</h5>
                            <button style={{ cursor: exportData?.length > 0 ? 'pointer' : 'not-allowed' }} className="btn btn-secondary" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>
                        <div className="gridshad mt-3">
                            <div className="occupancy-table-wrapper" style={{ maxHeight: 600 }}>
                                <table className="table occupancy-table">
                                    <thead>
                                        {/* GROUP HEADER */}
                                        <tr>
                                            <th
                                                rowSpan="2"
                                                colSpan="3"
                                                className="property-header"
                                            >
                                                Property Name
                                            </th>

                                            <th
                                                colSpan="6"
                                                className="group-header developer-header"
                                            >
                                                Developer
                                            </th>

                                            <th
                                                colSpan="6"
                                                className="group-header pm-header"
                                            >
                                                PM
                                            </th>

                                            <th
                                                colSpan="6"
                                                className="group-header overall-header"
                                            >
                                                Overall
                                            </th>
                                        </tr>

                                        {/* COLUMN HEADER */}
                                        <tr>
                                            {/* Developer */}
                                            <th className="developer-subheader">Total</th>
                                            <th className="developer-subheader">Occupied</th>
                                            <th className="developer-subheader">Occupied %</th>
                                            <th className="developer-subheader">Vacant</th>
                                            <th className="developer-subheader">On Notice</th>
                                            <th className="developer-subheader">Expected Arrival</th>

                                            {/* PM */}
                                            <th className="pm-subheader">Total</th>
                                            <th className="pm-subheader">Occupied</th>
                                            <th className="pm-subheader">Occupied %</th>
                                            <th className="pm-subheader">Vacant</th>
                                            <th className="pm-subheader">On Notice</th>
                                            <th className="pm-subheader">Expected Arrival</th>

                                            {/* Overall */}
                                            <th className="overall-subheader">Total</th>
                                            <th className="overall-subheader">Occupied</th>
                                            <th className="overall-subheader">Occupied %</th>
                                            <th className="overall-subheader">Vacant</th>
                                            <th className="overall-subheader">Notice</th>
                                            <th className="overall-subheader">Expected Arrival</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rowData.length > 0 ? (
                                            rowData.map((row, index) => (
                                                <tr key={`${row.propertyName}-${index}`}>
                                                    <td
                                                        colSpan="3"
                                                        className="property-name"
                                                    >
                                                        {row.propertyName || "-"}
                                                    </td>
                                                    <td>
                                                        {row.total ?? 0}
                                                    </td>

                                                    <td>
                                                        {row.occupied ?? 0}
                                                    </td>

                                                    <td className="percentage-cell">
                                                        {toPercent(row.occu_Per)}%
                                                    </td>
                                                    <td>
                                                        {row.vacant ?? 0}
                                                    </td>
                                                    <td>
                                                        {row.onNotice ?? 0}
                                                    </td>
                                                    <td>
                                                        {row.expectedArrival ?? 0}
                                                    </td>
                                                    <td>
                                                        {row.pM_Total ?? 0}
                                                    </td>

                                                    <td>
                                                        {row.pM_Occupied ?? 0}
                                                    </td>

                                                    <td className="percentage-cell">
                                                        {toPercent(row.pM_Occu_Per)}%
                                                    </td>

                                                    <td>
                                                        {row.pM_Vacant ?? 0}
                                                    </td>

                                                    <td>
                                                        {row.pM_OnNotice ?? 0}
                                                    </td>

                                                    <td>
                                                        {row.pM_ExpectedArrival ?? 0}
                                                    </td>

                                                    <td>
                                                        {row.property_Total ?? 0}
                                                    </td>

                                                    <td>
                                                        {row.property_Occupied ?? 0}
                                                    </td>

                                                    <td className="percentage-cell">
                                                        {toPercent(row.occupied_Per)}%
                                                    </td>

                                                    <td>
                                                        {row.property_Vacant ?? 0}
                                                    </td>

                                                    <td>
                                                        {row.property_Notice ?? 0}
                                                    </td>

                                                    <td>
                                                        {row.property_ExpectedArrival ?? 0}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="21"
                                                    className="text-center py-4 text-muted"
                                                >
                                                    No unit analysis data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                    {rowData.length > 0 && (
                                        <tfoot>
                                            <tr className="total-row">
                                                <td colSpan="3">
                                                    Total:
                                                </td>

                                                {/* Developer */}

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.total || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.occupied || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {(
                                                        (
                                                            rowData.reduce(
                                                                (sum, row) => sum + Number(row.occupied || 0),
                                                                0
                                                            ) /
                                                            rowData.reduce(
                                                                (sum, row) => sum + Number(row.total || 0),
                                                                0
                                                            )
                                                        ) * 100 || 0
                                                    ).toFixed(2)}%
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.vacant || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.onNotice || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.expectedArrival || 0),
                                                        0
                                                    )}
                                                </td>

                                                {/* PM */}

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.pM_Total || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.pM_Occupied || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {(
                                                        (
                                                            rowData.reduce(
                                                                (sum, row) => sum + Number(row.pM_Occupied || 0),
                                                                0
                                                            ) /
                                                            rowData.reduce(
                                                                (sum, row) => sum + Number(row.pM_Total || 0),
                                                                0
                                                            )
                                                        ) * 100 || 0
                                                    ).toFixed(2)}%
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.pM_Vacant || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.pM_OnNotice || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.pM_ExpectedArrival || 0),
                                                        0
                                                    )}
                                                </td>

                                                {/* Overall */}

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.property_Total || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.property_Occupied || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {(
                                                        (
                                                            rowData.reduce(
                                                                (sum, row) => sum + Number(row.property_Occupied || 0),
                                                                0
                                                            ) /
                                                            rowData.reduce(
                                                                (sum, row) => sum + Number(row.property_Total || 0),
                                                                0
                                                            )
                                                        ) * 100 || 0
                                                    ).toFixed(2)}%
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.property_Vacant || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.property_Notice || 0),
                                                        0
                                                    )}
                                                </td>

                                                <td>
                                                    {rowData.reduce(
                                                        (sum, row) => sum + Number(row.property_ExpectedArrival || 0),
                                                        0
                                                    )}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    )}
                                </table>
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
export default UnitAnalysisStatus;
